export default __webpack_public_path__ + "static/media/background-bottom-left.5f3566ca.png";